import { FilterMatchMode } from 'primereact/api';
import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { InputText } from 'primereact/inputtext';
import React, { useState } from 'react';

import { exportExcel } from './scorecard-payout-criteria-service';
import './scorecardPayoutCriteria.scss';
import { useGetScorecardPayoutCriteriaQuery } from './scorecardPayoutCriteriaSlice';
import { SCPayoutCriteriaDetails } from '../scPayoutCriteriaDetails/SCPayoutCriteriaDetails';

interface ScorecardPayoutCriteriaProps {
    inputyear?: number;
    inputmonth?: number;
    inputScorecardVersion?: number;
}

export const ScorecardPayoutCriteria = ({
    inputyear,
    inputmonth,
    inputScorecardVersion,
}: ScorecardPayoutCriteriaProps) => {
    const [expandedRows, setExpandedRows] = useState<any>();
    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    });
    const { data: scorecardPayoutCriteria } = useGetScorecardPayoutCriteriaQuery(
        {
            year: inputyear,
            month: inputmonth,
            scorecardVersionId: inputScorecardVersion,
        },
        { skip: !inputyear || !inputmonth || !inputScorecardVersion }
    );

    const onGlobalFilterChange = (e: any) => {
        const value = e.target.value;
        const afilters = { ...filters };
        afilters.global.value = value;
        setFilters(afilters);
        setGlobalFilterValue(value);
    };

    const allowExpansion = (rowData: any) => {
        if (rowData) return true;
        else return false;
    };

    const rowExpansionTemplate = (rowData: any) => {
        return (
            <div className="orders-subtable">
                <SCPayoutCriteriaDetails payoutCriteriaDetail={rowData} /> 
            </div>
        );
    };

    const renderHeader = () => {
        return (
            <div className="flex justify-content-between exportexcel">
                <span className="p-input-icon-left">
                    <i className="pi pi-search" />
                    <InputText
                        value={globalFilterValue}
                        onChange={onGlobalFilterChange}
                        placeholder="Search"
                    />
                </span>
                <Button
                    type="button"
                    icon="pi pi-arrow-up me-2"
                    className="btn-export mr-2 me-2 float-end"
                    onClick={() => {
                        exportExcel(scorecardPayoutCriteria?.data);
                    }}
                    data-pr-tooltip="XLS"
                >
                    Export
                </Button>
            </div>
        );
    };

    const header = renderHeader();
    return (
        <div className="card mt-3 ms-0 me-0 shadow bg-body rounded border-0">
            <div
                className="card-header border-0"
                style={{ backgroundColor: '#e0f0ff', padding: '15px', color: '#2B3A42' }}
            >
                Scorecard: {scorecardPayoutCriteria?.data[0]?.scorecard_name}
            </div>
            <div className="card-body p-0 align-middle text-center table">
                <DataTable
                    value={scorecardPayoutCriteria?.data}
                    header={header}
                    rowExpansionTemplate={rowExpansionTemplate}
                    expandedRows={expandedRows}
                    onRowToggle={(e) => {
                        setExpandedRows(e.data);
                    }}
                    className="scorecardPayoutCriteria"
                    rows={5}
                    paginator={scorecardPayoutCriteria?.data?.length > 5}
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    rowsPerPageOptions={[5, 10, 25, 50]}
                    filters={filters}
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                >
                    <Column
                        header="Name"
                        field="employee_name"
                        headerStyle={{ fontSize: 14, minWidth: '15rem' }}
                        bodyStyle={{ minWidth: '15rem' }}
                        sortable
                        sortField="employee_name"
                    />
                    <Column
                        header="Role"
                        field="scorecard_role_name"
                        headerStyle={{ fontSize: 14, minWidth: '15rem' }}
                        bodyStyle={{ minWidth: '15rem' }}
                        sortable
                        sortField="scorecard_role_name"
                    />
                    <Column
                        header="Scorecard Name"
                        field="scorecard_name"
                        headerStyle={{ fontSize: 14, minWidth: '15rem' }}
                        bodyStyle={{ minWidth: '15rem' }}
                        sortable
                        sortField="scorecard_name"
                    />
                    <Column
                        header="Total Metrics Attained"
                        field="total_metrics_attained"
                        headerStyle={{fontSize: 14, minWidth: '15rem' }}
                        bodyStyle={{ minWidth: '15rem' }}
                        sortable
                        sortField="total_metrics_attained"
                    />
                    <Column
                        header="Total Metrics Reported"
                        field="total_metrics_reported"
                        headerStyle={{ fontSize: 14, minWidth: '15rem' }}
                        bodyStyle={{ minWidth: '15rem' }}
                        sortable
                        sortField="total_metrics_reported"
                    />
                    <Column
                        header="Attained"
                        field="attainment_achieved"
                        headerStyle={{ fontSize: 14, minWidth: '15rem' }}
                        bodyStyle={{ minWidth: '15rem' }}
                        sortable
                        sortField="attainment_achieved"
                    />
                    <Column
                        header="Payout"
                        field="payout"
                        headerStyle={{ fontSize: 14, minWidth: '15rem' }}
                        bodyStyle={{ minWidth: '15rem' }}
                        sortable
                        sortField="payout"
                    />
                    <Column
                        key="expand"
                        expander={allowExpansion}
                        style={{ width: '4em', marginRight: '10px' }}
                    />
                </DataTable>
            </div>
        </div>
    );
};
